/**
 * @name prepareConfirmBtnsText
 * @param actionKey {String} - Ключ события
 * @param actionType {Number} - Тип события
 */
export const prepareConfirmBtnsText = (actionKey) => {
  switch (actionKey) {
  case 'allow':
    return {
      confirmBtnText: 'Allow',
      cancelBtnText: 'Cancel',
      submitStyle: 'primary',
    };

  case 'disallow':
    return {
      confirmBtnText: 'Disallow',
      cancelBtnText: 'Cancel',
      submitStyle: 'primary',
    };

  default:
    return {
      confirmBtnText: '',
      cancelBtnText: '',
    };
  }
};

export const summernoteOptions = {
  minHeight: 200,
  focus: false,
  toolbar: [
    ['style', ['style', 'bold', 'italic']],
    ['lists', ['ul', 'ol']],
    ['para', ['paragraph']],
    ['color', ['forecolor', 'backcolor', 'clear']],
    ['insert', ['link', 'picture', 'video']],
    ['codeview', ['codeview']],
  ],
  disableDragAndDrop: true,
  styleTags: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
  popover: {
    image: [
      ['custom', ['imageAttributes']],
      ['imagesize', ['imageSize100', 'imageSize50', 'imageSize25']],
      ['float', ['floatLeft', 'floatRight', 'floatNone']],
      ['remove', ['removeMedia']],
    ],
  },
  dialogsFade: true,
  imageAttributes: {
    icon: '<i class="note-icon-pencil"/>',
    removeEmpty: true,
    disableUpload: true,
  },
};

export const prepareForm = (data, item) => {
  if (!data?.has('take_fee_from_user')) {
    data.append('take_fee_from_user', String(Number(item?.details?.take_fee_from_user)));
  }

  return data;
};

export const updateSelectedItem = (details, values) => {
  for (const key in values) {
    if (Object.hasOwnProperty.call(values, key)) {
      if (Object.hasOwnProperty.call(details, key) && !!details) {
        details[key] = values[key];
      }
      if (details?.options?.length) {
        details?.options?.forEach((opt, index) => {
          if (opt.code === key) {
            details.options[index].value = values[key];
          }
        });
      }
    }
  }
  return details;
};

export const updateFormValues = (values, form) => {
  for (const key in values) {
    if (Object.hasOwnProperty.call(values, key)) {
      if (Object.hasOwnProperty.call(form, key) && !!form) {
        form[key].value = values[key];
      }
    }
  }
};
